/**
 * AutomatikBand – Karte in der rechten Spalte, direkt unter ToDo.
 *
 * Zeigt je Automatik (DATEV, CSV→Umsatz, Rename-me) eine Zeile: Ampel, Name und
 * was ansteht. Ist alles erledigt, bleibt es unauffällig; hängt etwas, wird die
 * Zeile farbig. Ein Klick führt in den Postkorb.
 *
 * Ist das Backend nicht erreichbar, zeigt die Komponente gar nichts —
 * eine kaputte Statuskarte wäre schlimmer als keine.
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../api/config";
import { cacheLesen, cacheSchreiben } from "../../utils/seitenCache";
import "./AutomatikBand.css";
import GeminiWarnung from "../GeminiWarnung";

const CACHE_KEY = "postkorb.uebersicht";

const FARBE = {
  gruen: "#22c55e",
  gelb: "#f59e0b",
  rot: "#ef4444",
  blau: "#38bdf8",
  grau: "#64748b",
};

function kurztext(q) {
  if (q.ampel === "blau") return "läuft gerade";
  if (q.fehler) return q.fehler === 1 ? "1 Sache offen" : `${q.fehler} Sachen offen`;
  if (q.offen) return q.offen === 1 ? "1 Hinweis" : `${q.offen} Hinweise`;
  return "erledigt";
}

export default function AutomatikBand() {
  // Zuerst das zuletzt Gesehene zeigen — der Abruf dauert einige Sekunden,
  // weil dafür drei Dropbox-Ordner gelesen werden.
  const [daten, setDaten] = useState(() => cacheLesen(CACHE_KEY, 24 * 3600));
  const [laedt, setLaedt] = useState(false);
  const navigate = useNavigate();

  const laden = React.useCallback((frisch = false) => {
    setLaedt(true);
    fetch(`${API_BASE}/postkorb/api/uebersicht${frisch ? "?frisch=1" : ""}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (j?.success) {
          setDaten(j);
          cacheSchreiben(CACHE_KEY, j);
        }
      })
      .catch(() => {})
      .finally(() => setLaedt(false));
  }, []);

  // Im Hintergrund aktualisieren, während schon etwas zu sehen ist
  useEffect(() => { laden(false); }, [laden]);

  if (!daten || !daten.quellen?.length) return <GeminiWarnung />;

  return (
    <>
    <GeminiWarnung />
    <aside className="autob-karte">
      <div className="autob-kopf">
        <span className="autob-titel">⚙ Automatik</span>
        <button
          className={`autob-refresh${laedt ? " autob-dreht" : ""}`}
          title="Jetzt neu prüfen"
          onClick={() => laden(true)}
          disabled={laedt}
        >↻</button>
      </div>

      <div className="autob-liste">
        {daten.quellen.map((q) => {
          const farbe = FARBE[q.ampel] || FARBE.grau;
          const auffaellig = q.ampel === "rot" || q.ampel === "gelb";
          return (
            <button
              key={q.key}
              className="autob-zeile"
              onClick={() => navigate("/postkorb")}
              title={q.lauf_text}
            >
              <span className="autob-punkt" style={{ background: farbe }} />
              <span className="autob-name">{q.name}</span>
              <span className="autob-status" style={{ color: auffaellig ? farbe : "#94a3b8" }}>
                {kurztext(q)}
              </span>
            </button>
          );
        })}
      </div>

      <button className="autob-mehr" onClick={() => navigate("/postkorb")}>
        Zum Postkorb →
      </button>
    </aside>
    </>
  );
}
